export const getInitials = (name: string | undefined, isSystem = false) => {
  if (isSystem) {
    return "SY";
  }
  if (!name) {
    return "";
  }

  return name
    .split(" ")
    .map(n => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};
